export const SI_TIMEFRAME_PREFIX = "si.timeframe";
export const DAY = "day";
export const WEEK = "week";
export const MONTH = "month";
export const YEAR = "year";
export const TODAY = "si.common.today";
export const AGO = "ago";
